// Copyright (c) Move Closer 2022.

import { Component, Prop, Vue } from 'vue-property-decorator'
import { RawLocation } from 'vue-router'

import { PossibleOrderStatus } from '../../../contexts/orders/contracts/orders'

import { OrdersListItemProps } from '../../orders/molecules/OrdersListItem'
import { RouteNames } from '../../orders/routes'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
@Component<OrdersListItemMixin>({
  name: 'OrdersListItemMixin'
})
export class OrdersListItemMixin extends Vue {
  @Prop({ type: Object, required: true })
  public readonly item!: OrdersListItemProps['item']

  /**
   * Constructs order details route.
   */
  public get detailsLink (): RawLocation {
    return {
      name: this.orderRoute,
      params: { id: (this.item.id).toString() }
    }
  }

  public get isOrderRoute (): boolean {
    return this.$router.resolve({ name: this.orderRoute }).resolved.matched.length > 0
  }

  public get orderRoute (): string {
    return `orders.${RouteNames.Order}`
  }

  /**
   * Prepare status translation.
   * @param status
   */
  public status (status: string): string {
    const isStatusDefined = Object.values(PossibleOrderStatus).includes(status)

    if (!isStatusDefined) {
      return '-'
    }

    return this.$t(`front.orders.OrdersListItem.statuses.${status}`).toString()
  }
}
